import React from "react";
import { userAtom } from "#root/atoms/userAtom";
import { useAtom } from "jotai";

import { NavLink, Menu, MenuTarget, MenuDropdown, MenuItem, MenuLabel, Divider, AppShell } from "@mantine/core";
import { IconDashboard, IconPower, IconLogout } from "@tabler/icons-react";
import { navigate } from "vike/client/router";
import { reload } from "vike/client/router";
import { useState } from "react";
import { data } from "./data";
import { notifications } from "@mantine/notifications";

const FixFooter = ({ toggle }: { toggle: () => void }) => {
  const [user, setUser] = useAtom(userAtom);
  const [opened, setOpened] = useState(false);

  const isAdmin = user?.role === "admin";
  const isConnected = !!user?.role;

  const handleDashboardClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!isAdmin) return;
    setOpened((o) => !o);
  };

  const handleAuthClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (isConnected) {
      toggle();
      const res = await fetch("/api/auth/signout", { method: "POST" });

      if (res.ok) {
        setUser(null);
        await navigate("/");
        notifications.show({
          title: "Logout successfull",
          message: "Nice to see you !",
        });

        await reload();
      } else {
        const { message } = await res.json();
        console.error("Signout error", message);
      }
    } else {
      toggle();
      await navigate("/login");
    }
  };

  return (
    <AppShell>
      {/* Divider always shown above */}
      <Divider />

      {/* Dashboard menu (admin only) */}
      {isAdmin && (
        <Menu
          shadow="md"
          position="bottom-start"
          withinPortal
          trapFocus
          width={200}
          opened={opened}
          onChange={setOpened}
        >
          <MenuTarget>
            <NavLink
              label="Dashboard"
              leftSection={<IconDashboard size={24} />}
              onClick={handleDashboardClick}
              variant="filled"
              active={opened}
            />
          </MenuTarget>

          <MenuDropdown>
            <Divider />
            {data.sections.map((section, index) => (
              <div key={index}>
                <MenuLabel>{section.label}</MenuLabel>
                {section.items.map((item, idx) => (
                  <MenuItem
                    key={idx}
                    leftSection={<item.icon size={24} />}
                    component="a"
                    href={item.href}
                    color={item.danger ? "red" : undefined}
                    aria-label={item.label}
                    onClick={() => {
                      toggle();
                    }}
                  >
                    {item.label}
                  </MenuItem>
                ))}
                {index !== data.sections.length - 1 && <Divider />}
              </div>
            ))}
          </MenuDropdown>
        </Menu>
      )}

      {/* Login / Logout NavLink (always visible) */}
      <NavLink
        label={isConnected ? "Logout" : "Login"}
        leftSection={isConnected ? <IconLogout size={24} /> : <IconPower size={24} />}
        onClick={handleAuthClick}
        variant="light"
        href="/login"
      />
    </AppShell>
  );
};

export default FixFooter;
